import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_mouse",
  "use": "icon-icon_mouse-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_mouse\"><defs><style></style></defs><path d=\"M512 51.2a317.85 317.85 0 0 1 317.44 317.44v286.72a317.44 317.44 0 0 1-634.88 0V368.64A317.85 317.85 0 0 1 512 51.2M512 0a369.664 369.664 0 0 0-368.64 368.64v286.72a368.64 368.64 0 0 0 737.28 0V368.64A369.664 369.664 0 0 0 512 0z\" /><path d=\"M512 384a25.6 25.6 0 0 1-25.6-25.6V199.68a25.6 25.6 0 0 1 51.2 0V358.4A25.6 25.6 0 0 1 512 384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol